module.exports = __webpack_public_path__ + "img/class.d988a32f.png";